import { getStaticOption } from '../../../core/forms/helpers/getStaticOption';
import { IDs } from '../../../helpers/IDs';
import * as React from 'react';

export function getAdditionalUnit(entity: string, field: string, values: any, data: any) {
    // WICHTIG
    // Aktuell ist das nur für WFormFieldNumber implementiert.
    // Sobald bei anderen Feldern auch Hinweise benötigt werden, sind diese dort zu ergänzen
    const unitStyle: React.CSSProperties = { whiteSpace: 'nowrap', marginRight: 10, marginLeft: 5 };
    // Dort wo "co2_fussabdruck_ghg" wirklich benötigt wird, muss data übergeben werden, sonst ist es egal
    // const co2_fussabdruck_ghg = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).co2_fussabdruck_modus === 'ghg';
    const einheitName: string = typeof (values || {}).einheit === 'string' ? getStaticOption(entity, 'einheit', values.einheit) : '';

    switch (entity) {
        case IDs.ENT_ENERGIEDATEN_WAERME:
            const einheit = (data[IDs.ENT_ENERGIEDATEN_WAERME_EINHEITEN] || []).find((r: any) => r.tid === values.einheit_tid || r.tid === values.einheit_tid_orig);
            if (field === 'verbrauch') {
                return <div style={unitStyle}>{einheit ? einheit.name : '?'}</div>;
            }
            if (field === 'co2_emissionen') {
                let einheit_co2: string;
                if (einheit && einheit.name === 'MWh') {
                    einheit_co2 = 'gCO₂/MWh'
                } else {
                    einheit_co2 = 'gCO₂/kWh'
                }
                return <div style={unitStyle}>{einheit_co2}</div>;
            }
            break;
        case IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN:    // no break
        case IDs.ENT_CO2_SCOPE3_EMITTENTEN:                 // no break
        case IDs.ENT_CO2_SCOPE3_FRANCHISE:                  // no break
        case IDs.ENT_CO2_SCOPE3_INVESTITION:                // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS:      // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG:           // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG:      // no break
        case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN:     // no break
            if (field === 'faktor') {
                return <div style={unitStyle}>kg CO₂ / {values.einheit ? einheitName : '?'}</div>;
            }
            break;
        case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF: // no break
        case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
            // if (field === 'menge') {
            //     let einheit = '?';
            //     if (values.modus === 'spend_based') {
            //         einheit = '€ (netto)';
            //     } else {
            //         einheit = (values.einheit && values.einheit !== '0') ? einheitName : '?';
            //     }
            //     return <div style={unitStyle}>{einheit ? einheit : '?'}</div>;
            // } else 
            if (field === 'menge') {
                let einheit: string = null;
                if (values.modus === 'spend_based') {
                    einheit = '€ (netto)';
                } else if (!values.modus) {
                    einheit = '?';
                }
                return einheit ? <div style={unitStyle}>{einheit}</div> : null;
            } else if (field === 'faktor') {
                // console.log('WF: ', values.einheit, values);
                if ((entity === IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL && !values.modus)
                    || ['supplier_specific', 'user_specific'].indexOf(values.modus) !== -1) {
                    return <div style={unitStyle}>kg CO₂ / {values.einheit && values.einheit !== '0' ? einheitName : '?'}</div>;
                }
            }
            break;
        case IDs.ENT_VSME_B5:
            const keys: string[] = [
                'grundstuecksflaeche', 'jahr_flaeche_naturnah_ausserhalb', 'jahr_flaeche_naturnah_standort', 'jahr_flaeche_nutzung',
                'jahr_flaeche_versiegelt', 'vorjahr_flaeche_naturnah_ausserhalb', 'vorjahr_flaeche_naturnah_standort',
                'vorjahr_flaeche_nutzung', 'vorjahr_flaeche_versiegelt'
            ];
            if (keys.indexOf(field) !== -1) {
                return <div style={unitStyle}>{values.einheit ? einheitName : '?'}</div>;
            }
            break;
        case IDs.ENT_VSME_B10:
            if (['einstiegslohn', 'mindestlohn'].indexOf(field) !== -1) {
                return <div style={unitStyle}>€ / {values.einheit ? einheitName : '?'}</div>;
            }
            if (['prozent_lohngefaelle'].indexOf(field) !== -1) {
                return <div style={unitStyle}>%</div>;
            }
            break;
        default:
            return null;
    }
}
